import {vnModule_knockoutJS} from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import {
    XMLHttpRequestHandler,
    XMLHttpRequestHandler_requestType
} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {config_login_template} from "../components/templates/config_login_template";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import {header} from "./header";
import {UploadStatusHandler} from "../utils/UploadStatusHandler";

declare var ko: any;
declare var page: any;


export class config_login extends vnModule_knockoutJS {

    protected XHRHdl: XMLHttpRequestHandler;
    protected imageXHRHdl: XMLHttpRequestHandler;
    protected configLogin: config_login_template;
    protected _isLeavePageWarningNeeded: boolean = true;
    public uploadStatus: UploadStatusHandler = new UploadStatusHandler();

    public fillPage() {
        this.getGeneralConfigData()
    }

    buildContent(): Array<Element> {
        this.configLogin = new config_login_template("config_login", this.viewModel, this);
        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("Login Settings");

        return [this.configLogin.build()];
    }

    protected getModuleName(): string {
        return "config_login";
    }

    private getGeneralConfigData() {
        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let usrReq_url: string = '/api/brand/' + idBrand + "/generalconfig/login-settings/get/";
        let usrReq_params: Array<Array<string>> = [];
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetGeneralConfigDataReturn;
        this.XHRHdl.execute();
    }

    private onGetGeneralConfigDataReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);

                let response = responseParsed.data;

                //set login system email templates
                obj.configLogin.setLoginSystemEmailTemplates(response.newsletterTemplates);
                obj.configLogin.setPersonalThreadNotificationEmailTemplates(response.allTemplates);
                obj.configLogin.setFollowUpdateNotificationEmailTemplates(response.allTemplates);

                if (response.loginSettings != null) {

                    obj.configLogin.setMaxUnauthenicatedArticleViews(response.loginSettings.maxUnauthenicatedArticleViews);
                    obj.configLogin.setLowRangeMinimumRate(response.loginSettings.lowRangeMinimumRate);
                    obj.configLogin.setLowRangeArticleTarget(response.loginSettings.lowRangeArticleTarget);
                    obj.configLogin.setMidRangeMinimumRate(response.loginSettings.midRangeMinimumRate);
                    obj.configLogin.setMidRangeArticleTarget(response.loginSettings.midRangeArticleTarget);
                    obj.configLogin.setHighRangeMinimumRate(response.loginSettings.highRangeMinimumRate);
                    obj.configLogin.setHighRangeArticleTarget(response.loginSettings.highRangeArticleTarget);
                    obj.configLogin.setSkipBannerEnable(response.loginSettings.skipBannerEnable ? true : false);
                    obj.configLogin.setSkipBannerEnableTopButton(response.loginSettings.skipBannerEnableTopButton ? true : false);
                    obj.configLogin.setNewsletterHeadline(response.loginSettings.newsletterHeadline);
                    obj.configLogin.setNewsletterDescription(response.loginSettings.newsletterDescription);
                    obj.configLogin.setNewsletterBackgroundImage(response.loginSettings.newsletterBackgroundImage);
                    obj.configLogin.setNewsletterBackgroundColor(response.loginSettings.newsletterBackgroundColor);
                    obj.configLogin.setPremiumOfferUrlForAdRemoval(response.loginSettings.premiumOfferUrlForAdRemoval);
                    obj.configLogin.setHasActionBar(response.loginSettings.hasActionBar);
                    obj.configLogin.setStyle(response.loginSettings.articleLimitStyle ? response.loginSettings.articleLimitStyle : 'popup');
                    obj.configLogin.setPercentageScrollDepthTrigger(response.loginSettings.percentageScrollDepthTrigger);
                    obj.configLogin.setSecondsOnPageTrigger(response.loginSettings.secondsOnPageTrigger);
                    obj.configLogin.setCollectionForm(response.loginSettings.collectionForm);
                    obj.configLogin.setHasThreadSuggestions(response.loginSettings.hasThreadSuggestions);
                    obj.configLogin.setCooldownTime(response.loginSettings.cooldownTime);
                    obj.configLogin.setCooldownArticleCount(response.loginSettings.cooldownArticleCount);
                    obj.configLogin.setGoogleClientId(response.loginSettings.googleClientId);
                    obj.configLogin.setAmazonClientId(response.loginSettings.amazonClientId);
                    obj.configLogin.setOpenPassClientId(response.loginSettings.openPassClientId);
                    obj.configLogin.setFacebookClientId(response.loginSettings.facebookClientId);
                    obj.configLogin.setFacebookClientSecret(response.loginSettings.facebookClientSecret);
                    obj.configLogin.setDiscordClientId(response.loginSettings.discordClientId);
                    obj.configLogin.setDiscordClientSecret(response.loginSettings.discordClientSecret);
                    obj.configLogin.setAppleClientId(response.loginSettings.appleClientId);
                    obj.configLogin.setSteamClientId(response.loginSettings.steamClientId);
                    obj.configLogin.setTwitchClientId(response.loginSettings.twitchClientId);
                    obj.configLogin.setTwitchClientSecret(response.loginSettings.twitchClientSecret);
                    obj.configLogin.setSortables(response.loginSettings.loginPlatformOrder);
                    if(response.loginSettings.loginSystemEmailTemplateId){
                        obj.configLogin.setLoginSystemEmailTemplate(response.loginSettings.loginSystemEmailTemplateId);
                    }
                    if(response.loginSettings.personalThreadNotificationEmailTemplateId){
                        obj.configLogin.setPersonalThreadNotificationEmailTemplate(response.loginSettings.personalThreadNotificationEmailTemplateId);
                    }

                    if(response.loginSettings.followUpdateNotificationEmailTemplateId){
                        obj.configLogin.setFollowUpdateNotificationEmailTemplate(response.loginSettings.followUpdateNotificationEmailTemplateId);
                    }
                }
            });
        }
    }

    public filterDropdownOnChange(data) {
        // dropdowns cry without this, we don't really need it
    }

    public getUrlBase(): string {
        let idBrand = this.getVnAppZone().app.params.idBrand;
        return idBrand ? "/api/brand/" + idBrand : "/api";
    }

    public getImageData() {
        if (this.imageXHRHdl) {
            this.imageXHRHdl.cancelAndReset();
        }

        this.configLogin.imagePicker.showLoading();

        let formReq_url: string = this.getUrlBase() + "/images/get/";
        let formReq_params: Array<Array<string>> = [];

        formReq_params.push([
            "data",
            ko.toJSON(this.configLogin.imagePicker.getViewModelForRequest()),
        ]);

        this.imageXHRHdl = new XMLHttpRequestHandler(
            formReq_url,
            formReq_params,
            this
        );
        this.imageXHRHdl.mode = XMLHttpRequestHandler_requestType.GET;
        this.imageXHRHdl.onReadyStateFunction = this.onGetImageDataReturn;
        this.imageXHRHdl.execute();
    }

    protected onGetImageDataReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);
                obj.updateImagePickerForm(responseParsed);
                obj.configLogin.imagePicker.hideLoading();
            });
        };
    }

    public updateImagePickerForm(responseParsed) {
        let selectedImages = this.configLogin.imagePicker.getSelectedImages();

        if (responseParsed.paginatedImages && responseParsed.paginatedImages.data) {
            for (let image of responseParsed.paginatedImages.data) {
                image.selected = false;
                let imageSelected = selectedImages.find((i) => i.id == image.id);
                if (imageSelected) {
                    image.selected = true;
                }
                image.fileSize = this.bytesToSize(image.fileSize);
            }
            this.configLogin.imagePicker.setImagesPagination(
                responseParsed.paginatedImages
            );
            this.configLogin.imagePicker.setImageResults(
                responseParsed.paginatedImages.data
            );
        }

        if (responseParsed.ratios) {
            this.configLogin.imagePicker.setRatios(responseParsed.ratios);
        }

        if (responseParsed.orientations) {
            this.configLogin.imagePicker.setOrientations(responseParsed.orientations);
        }

        if (responseParsed.uploadSources) {
            this.configLogin.imagePicker.setUploadSources(
                responseParsed.uploadSources,
                responseParsed.selectedUploadSource
            );
        }

        if (responseParsed.idBrand) {
            this.configLogin.imagePicker.setIdBrand(responseParsed.idBrand);
        }
    }

    protected bytesToSize(bytes) {
        var sizes = ["KB", "MB", "GB", "TB"];
        if (bytes == 0) return "n/a";
        var i = parseInt(String(Math.floor(Math.log(bytes) / Math.log(1024))));
        if (i == 0) return bytes + " " + sizes[i];
        return (bytes / Math.pow(1024, i)).toFixed(1) + " " + sizes[i];
    }

    public insertImage(image, target) {
        if (target == "newsletterBackgroundImage") {
            this.configLogin.imageWidgetForNewsletterBackgroundImage.setImage(image);
        }
    }

    public setImage(image, target) {
        if (target == "newsletterBackgroundImage") {
            this.configLogin.imageWidgetForNewsletterBackgroundImage.setImage(image);
        }
    }

    public saveImages(images, insert, param, insertType = "image", widget = null) {
        let formReq_url: string = this.getUrlBase() + "/images/save/";
        let formReq_params: Array<Array<string>> = [];

        let targetWidget = widget ? widget : this.configLogin.imageWidgetForNewsletterBackgroundImage;

        formReq_params.push(["data", ko.toJSON(images)]);

        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(
            formReq_url,
            formReq_params,
            this
        );
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = function (req, obj) {
            return function () {
                obj.manageResponse(req, obj, function () {
                    let response = JSON.parse(req.request.response);

                    targetWidget.setImage(response.images[0].image);
                    obj.configLogin.imagePicker.onImageSaveReturn(
                        response.images,
                        insert,
                        param,
                        insertType
                    );
                    obj.getImageData();
                });
            };
        };
        XHRHdl.execute();
    }

    protected handleFiles(files) {
        this.uploadImages(files);
    }

    protected uploadImages(files) {
        let idBrand = this.getVnAppZone().app.params.idBrand;
        let formReq_url: string = this.getUrlBase() + "/images/upload/";

        var formData = new FormData();

        if (files.length > 1) {
            this.configLogin.imagePicker.hideImageAdd();
            this.configLogin.imagePicker.showLoading();
        }

        this.configLogin.imagePicker.clearFilters();
        this.uploadStatus.nextTrial();

        for (let i = 0; i < files.length; i++) {
            formData.append("file_" + i, files[i]);
        }
        if (idBrand) {
            formData.append("idBrand", idBrand);
        }

        let request = [];
        var xhttp = new XMLHttpRequest();
        request["request"] = xhttp;

        xhttp.open("POST", formReq_url, true);

        let onReadyStateFunction = function (req, obj) {
            return function () {
                if (req.request.readyState == 4) {
                    if (req.request.status == 200) {
                        obj.uploadStatus.reset();
                        let fileElement: any = document.getElementById("fileElem");
                        if (fileElement) fileElement.value = "";
                        let response = JSON.parse(req.request.response);

                        if (response.images.length == 1 && response.errors.length == 0) {
                            obj.configLogin.imagePicker.editImage(response.images[0]);
                            obj.configLogin.imagePicker.hideLoading();
                        }

                        if ((response.images.length == 1 && response.errors.length == 1) || response.images.length > 1) {
                            obj.configLogin.imagePicker.hideImageAdd();
                            obj.configLogin.imagePicker.handleBulkImages(response.images);
                            obj.configLogin.imagePicker.hideLoading();

                            if (response.errors.length == 1) {
                                obj.configLogin.imagePicker.imagesBulkEdit.validationsList.setMessages(response.errors);
                            }
                        }
                    }
                }
            };
        };

        xhttp.onreadystatechange = onReadyStateFunction(request, this);
        xhttp.send(formData);
    }

    public deleteImage(image) {
        let formReq_url: string = this.getUrlBase() + "/images/delete/";
        let formReq_params: Array<Array<string>> = [];
        formReq_params.push(["data", ko.toJSON(image)]);

        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(
            formReq_url,
            formReq_params,
            this
        );
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = function (req, obj) {
            return function () {
                obj.manageResponse(req, obj, function () {
                    obj.getImageData();
                });
            };
        };
        XHRHdl.execute();
    }

    protected saveLoginSettings(param, data) {
        this.loadingIn(this.configLogin.builtTemplate);
        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let formReq_url: string = '/api/brand/' + idBrand + "/generalconfig/login-settings/save/";
        let formReq_params: Array<Array<string>> = [];

        let subViewModel = JSON.parse(ko.toJSON(this.configLogin.getLoginSettings()));
        formReq_params.push(["data", ko.toJSON(subViewModel)]);

        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;

        XHRHdl.onReadyStateFunction = (function (req, obj) {

            return function () {

                obj.manageResponse(req, obj, function () {

                    let idBrand = obj.getVnAppZone().getApp().params.idBrand;
                    page.redirect("/brand/"+idBrand+"/config/login/");

                });
                obj.loadingOut(obj.configLogin.builtTemplate);
                obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "SAVED!");

            }
        });
        XHRHdl.execute();
    }


    protected cancelSiteSettings() {
        this.backAction()
        this.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, "LOGIN SETTINGS changes cancelled!");
    }

    protected backAction(){
        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        page.redirect("/brand/"+idBrand+"/config/login/");
    }
}



// WEBPACK FOOTER //
// ./js/modules/config_login.ts